import { Controller } from "@hotwired/stimulus"

// Persists <details> open/closed state across Turbo re-renders. The process
// context panel is rebroadcast via `turbo_stream_from` whenever a task changes,
// which would otherwise reset every collapsed task group back to its
// server-rendered default. We stash each section's state in sessionStorage
// (keyed per process + group) and restore it on connect so a user's expand /
// collapse choices survive the next broadcast.
export default class extends Controller {
  static targets = ["section"]

  connect() {
    this.sectionTargets.forEach((el) => {
      const stored = this.read(el.dataset.key)
      if (stored === "open") el.open = true
      else if (stored === "closed") el.open = false
    })
  }

  save(event) {
    const el = event.currentTarget
    this.write(el.dataset.key, el.open ? "open" : "closed")
  }

  read(key) {
    if (!key) return null
    try {
      return window.sessionStorage.getItem(`pw-details:${key}`)
    } catch {
      return null
    }
  }

  write(key, value) {
    if (!key) return
    try {
      window.sessionStorage.setItem(`pw-details:${key}`, value)
    } catch {
      // sessionStorage can be unavailable (private mode / quota) — collapse
      // memory is a nicety, so fail silently rather than break the panel.
    }
  }
}
